import axios from 'axios';

// 🔥 YENİ: Auth token'ı ekleyen interceptor
const setupInterceptors = () => {
  axios.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem('token');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      console.log('🚀 API Request:', config.method?.toUpperCase(), config.url);
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  axios.interceptors.response.use(
    (response) => {
      console.log('✅ API Response:', response.status, response.data);
      return response;
    },
    (error) => {
      console.error('❌ API Error:', error.response?.status, error.message);

      // 401 Unauthorized - token geçersiz
      if (error.response?.status === 401) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/login';
      }

      return Promise.reject(error);
    }
  );
};

// Interceptor'ı başlat
setupInterceptors();


const API_BASE_URL = 'https://medi-panel.cloud/api/shopify';

// Axios instance oluştur
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000, // 30 saniye (sync işlemleri için daha uzun)
});

class ShopifyService {

  // Backend bağlantı testi - YENİ ENDPOINT
  async testConnection() {
    try {
      console.log('🔗 Backend connection test başlıyor...');

      const response = await fetch(`${API_BASE_URL}/health`);
      console.log('📡 Fetch response:', response.status, response.ok);

      if (response.ok) {
        const data = await response.json();
        console.log('✅ Backend çalışıyor! Data:', data);
        return {
          success: true,
          data: data,
          message: '✅ Backend bağlantısı başarılı!'
        };
      } else {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
    } catch (error) {
      console.error('❌ Backend test hatası:', error);
      return {
        success: false,
        message: `Bağlantı hatası: ${error.message}`,
        error: error.message
      };
    }
  }

  // 📊 ANALYTICS METHODS - YENİ ENDPOINT'LER

  // Shopify ürün sayısı - YENİ (AUTH GÜNCELLEMESİ)
  async getShopifyProductCount() {
    try {
      console.log('📦 Shopify ürün sayısı alınıyor...');

      // 🔥 YENİ: Token'ı al
      const token = localStorage.getItem('token');

      const response = await fetch(`${API_BASE_URL}/analytics/shopify-count`, {
        headers: {
          'Authorization': `Bearer ${token}`,  // 🔥 YENİ: Token header'ı
          'Content-Type': 'application/json'
        }
      });

      console.log('📡 Response status:', response.status);

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      console.log('✅ Shopify ürün sayısı alındı:', data);
      return data;

    } catch (error) {
      console.error('❌ Shopify ürün sayısı alma hatası:', error);
      throw error;
    }
  }

  // Database ürün sayısı - YENİ (AUTH GÜNCELLEMESİ)
  async getDatabaseProductCount() {
    try {
      console.log('💾 Database ürün sayısı alınıyor...');

      // 🔥 YENİ: Token'ı al
      const token = localStorage.getItem('token');

      const response = await fetch(`${API_BASE_URL}/analytics/database-count`, {
        headers: {
          'Authorization': `Bearer ${token}`,  // 🔥 YENİ: Token header'ı
          'Content-Type': 'application/json'
        }
      });

      console.log('📡 Response status:', response.status);

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      console.log('✅ Database ürün sayısı alındı:', data);
      return data;

    } catch (error) {
      console.error('❌ Database ürün sayısı alma hatası:', error);
      throw error;
    }
  }


  // Sync durumu analizi - YENİ (AUTH GÜNCELLEMESİ)
  async getSyncStatusAnalysis() {
    try {
      console.log('📈 Sync durumu analizi alınıyor...');

      // 🔥 YENİ: Token'ı al
      const token = localStorage.getItem('token');
      console.log('🔐 Using token:', token ? `✅ (${token.length} chars)` : '❌ MISSING');

      const response = await fetch(`${API_BASE_URL}/analytics/sync-status`, {
        headers: {
          'Authorization': `Bearer ${token}`,  // 🔥 YENİ: Token header'ı
          'Content-Type': 'application/json'
        }
      });

      console.log('📡 Response status:', response.status, response.statusText);

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      console.log('✅ Sync durumu analizi alındı:', data);
      return data;

    } catch (error) {
      console.error('❌ Sync durumu analizi hatası:', error);

      // 🔥 DETAYLI HATA AYIKLAMA
      if (error.response) {
        // Backend'den hata geldi
        console.error('🔧 Backend Error Details:', {
          status: error.response.status,
          data: error.response.data,
          headers: error.response.headers
        });

        throw new Error(`Backend Error (${error.response.status}): ${error.response.data?.message || 'Unknown error'}`);
      } else if (error.request) {
        // İstek atıldı ama cevap alınamadı
        console.error('🔧 Network Error Details:', error.request);
        throw new Error('Network Error: Backend not responding');
      } else {
        // Diğer hatalar
        console.error('🔧 Other Error:', error.message);
        throw new Error(`Request Error: ${error.message}`);
      }
    }
  }

  // 🔄 SYNC METHODS - YENİ ENDPOINT'LER

  // Tam sync başlat - YENİ ENDPOINT
  // Tam sync başlat - YENİ ENDPOINT (AUTH GÜNCELLEMESİ)
  async triggerFullSync() {
    try {
      console.log('🚀 Tam sync başlatılıyor...');

      // 🔥 YENİ: Token'ı al
      const token = localStorage.getItem('token');

      const response = await fetch(`${API_BASE_URL}/sync/full`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,  // 🔥 YENİ: Token header'ı
          'Content-Type': 'application/json',
        }
      });

      console.log('📡 Response status:', response.status);

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      console.log('✅ Tam sync başarılı:', data);
      return data;

    } catch (error) {
      console.error('❌ Tam sync hatası:', error);
      throw error;
    }
  }


  // Günlük sync başlat - YENİ ENDPOINT (AUTH GÜNCELLEMESİ)
  async triggerIncrementalSync() {
    console.log('🔍 DEBUG: Günlük sync başlatılıyor...');

    try {
      console.log('🌅 1. Günlük sync başlıyor...');
      const url = `${API_BASE_URL}/sync/incremental`;
      console.log('🔗 2. URL:', url);

      // 🔥 YENİ: Token'ı al
      const token = localStorage.getItem('token');
      console.log('🔐 3. Token:', token ? `✅ (${token.length} chars)` : '❌ MISSING');

      console.log('📡 4. Fetch isteği gönderiliyor...');
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,  // 🔥 YENİ: Token header'ı
          'Content-Type': 'application/json',
        }
      });

      console.log('✅ 5. Fetch CEVAP ALINDI! Status:', response.status, response.statusText);

      if (!response.ok) {
        console.log('❌ 6. HTTP Hatası:', response.status, response.statusText);
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      console.log('📊 7. Response JSON parse ediliyor...');
      const data = await response.json();
      console.log('🎉 8. Günlük sync BAŞARILI:', data);

      return data;

    } catch (error) {
      console.log('💥 9. CATCH BLOĞU: Hata yakalandı!');
      console.log('🔴 HATA TİPİ:', error.name);
      console.log('🔴 HATA MESAJI:', error.message);
      console.log('🔴 HATA STACK:', error.stack);
      throw error;
    }
  }

  // Test sync başlat - YENİ ENDPOINT
  // Test sync başlat - YENİ ENDPOINT (AUTH GÜNCELLEMESİ)
  async triggerTestSync() {
    try {
      console.log('🧪 Test sync başlatılıyor...');

      // 🔥 YENİ: Token'ı al
      const token = localStorage.getItem('token');

      const response = await fetch(`${API_BASE_URL}/sync/test`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,  // 🔥 YENİ: Token header'ı
          'Content-Type': 'application/json',
        }
      });

      console.log('📡 Response status:', response.status);

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      console.log('✅ Test sync başarılı:', data);
      return data;

    } catch (error) {
      console.error('❌ Test sync hatası:', error);
      throw error;
    }
  }

  // 📦 PRODUCT METHODS - ESKİ METODLARI DA KORU

  // SKU'ya göre ürün ara
  async searchProductBySku(sku) {
    try {
      console.log('🔍 SKU ile ürün aranıyor:', sku);
      const response = await fetch(`${API_BASE_URL}/products/search?sku=${encodeURIComponent(sku)}`);

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('❌ Ürün arama hatası:', error);
      throw new Error(`Ürün bulunamadı: ${error.message}`);
    }
  }

  // ID'ye göre ürün getir
  async getProductById(productId) {
    try {
      console.log('🔍 ID ile ürün getiriliyor:', productId);
      const response = await fetch(`${API_BASE_URL}/products/${productId}`);

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('❌ Ürün getirme hatası:', error);
      throw new Error(`Ürün getirilemedi: ${error.message}`);
    }
  }

  // Tüm ürünleri listele (sayfalı)
  async getAllProducts(page = 0, size = 20) {
    try {
      console.log('📦 Ürünler listeleniyor:', { page, size });
      const response = await fetch(`${API_BASE_URL}/products?page=${page}&size=${size}`);

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('❌ Ürün listeleme hatası:', error);
      throw new Error(`Ürünler listelenemedi: ${error.message}`);
    }
  }

  // 🎯 ÜRÜN YÖNETİMİ METODLARI

  // Ürün durumunu güncelle
  async updateProductStatus(productId, status) {
    try {
      console.log('📝 Ürün durumu güncelleniyor:', { productId, status });
      const response = await fetch(
        `${API_BASE_URL}/products/${productId}/status?status=${status}`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          }
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      console.log('✅ Ürün durumu güncellendi:', data);
      return data;

    } catch (error) {
      console.error('❌ Ürün durumu güncelleme hatası:', error);
      throw error;
    }
  }

  // Variant fiyatını güncelle
  async updateVariantPrice(variantId, price) {
    try {
      console.log('💰 Variant fiyatı güncelleniyor:', { variantId, price });
      const response = await fetch(
        `${API_BASE_URL}/products/variants/${variantId}/price?price=${encodeURIComponent(price)}`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          }
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      console.log('✅ Variant fiyatı güncellendi:', data);
      return data;

    } catch (error) {
      console.error('❌ Variant fiyat güncelleme hatası:', error);
      throw error;
    }
  }

  // Variant stok güncelle
  async updateVariantInventory(variantId, inventoryQuantity) {
    try {
      console.log('📦 Variant stok güncelleniyor:', { variantId, inventoryQuantity });
      const response = await fetch(
        `${API_BASE_URL}/products/variants/${variantId}/inventory?inventoryQuantity=${inventoryQuantity}`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          }
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      console.log('✅ Variant stok güncellendi:', data);
      return data;

    } catch (error) {
      console.error('❌ Variant stok güncelleme hatası:', error);
      throw error;
    }
  }

  // Toplu güncelleme
  async updateProductBulk(updates) {
    try {
      console.log('🔄 Toplu güncelleme başlatılıyor:', updates);
      const response = await fetch(`${API_BASE_URL}/products/bulk-update`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updates)
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      console.log('✅ Toplu güncelleme tamamlandı:', data);
      return data;

    } catch (error) {
      console.error('❌ Toplu güncelleme hatası:', error);
      throw error;
    }
  }

  // Ürün detaylarını getir
  async getProductDetails(productId) {
    try {
      console.log('🔍 Ürün detayları getiriliyor:', productId);
      const response = await fetch(`${API_BASE_URL}/products/${productId}/details`);

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      return data;

    } catch (error) {
      console.error('❌ Ürün detayları getirme hatası:', error);
      throw error;
    }
  }

  // Fiyat güncelle - YENİ ENDPOINT
  async updateProductPrice(variantId, newPrice) {
    try {
      console.log('💰 Fiyat güncelleniyor:', { variantId, newPrice });
      const response = await fetch(
        `${API_BASE_URL}/products/variants/${variantId}/price?newPrice=${encodeURIComponent(newPrice)}`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          }
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      console.log('✅ Fiyat güncelleme başarılı:', data);
      return data;

    } catch (error) {
      console.error('❌ Fiyat güncelleme hatası:', error);
      throw error;
    }
  }

  // 🎯 ÜRÜN YÖNETİMİ METODLARI

  // Ürün durumunu güncelle
  async updateProductStatus(productId, status) {
    try {
      console.log('📝 Ürün durumu güncelleniyor:', { productId, status });
      const response = await fetch(
        `https://medi-panel.cloud/api/shopify/products/${productId}/status?status=${status}`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          }
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      console.log('✅ Ürün durumu güncellendi:', data);
      return data;

    } catch (error) {
      console.error('❌ Ürün durumu güncelleme hatası:', error);
      throw error;
    }
  }

  // Variant stok güncelle
  async updateVariantInventory(variantId, inventoryQuantity) {
    try {
      console.log('📦 Variant stok güncelleniyor:', { variantId, inventoryQuantity });
      const response = await fetch(
        `https://medi-panel.cloud/api/shopify/products/variants/${variantId}/inventory?inventoryQuantity=${inventoryQuantity}`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          }
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      console.log('✅ Variant stok güncellendi:', data);
      return data;

    } catch (error) {
      console.error('❌ Variant stok güncelleme hatası:', error);
      throw error;
    }
  }

  // Toplu güncelleme
  async updateProductBulk(updates) {
    try {
      console.log('🔄 Toplu güncelleme başlatılıyor:', updates);
      const response = await fetch('https://medi-panel.cloud/api/shopify/products/bulk-update', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updates)
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      console.log('✅ Toplu güncelleme tamamlandı:', data);
      return data;

    } catch (error) {
      console.error('❌ Toplu güncelleme hatası:', error);
      throw error;
    }
  }

  // Ürün detaylarını getir
  async getProductDetails(productId) {
    try {
      console.log('🔍 Ürün detayları getiriliyor:', productId);
      // Mevcut getProductById metodunu kullanabiliriz
      return await this.getProductById(productId);
    } catch (error) {
      console.error('❌ Ürün detayları getirme hatası:', error);
      throw error;
    }
  }

  // 🎯 VENDOR METODLARI

  // Tüm vendor'ları getir
  async getAllVendors() {
    try {
      console.log('🏪 Tüm vendor\'lar getiriliyor...');
      const response = await fetch('https://medi-panel.cloud/api/shopify/vendors');

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      console.log('✅ Vendor\'lar getirildi:', data);
      return data;

    } catch (error) {
      console.error('❌ Vendor getirme hatası:', error);
      throw error;
    }
  }

  // Vendor'a göre ürünleri getir
  async getProductsByVendor(vendorName, status = 'all') {
    try {
      console.log('🔍 Vendor ürünleri getiriliyor:', { vendorName, status });
      const response = await fetch(
        `https://medi-panel.cloud/api/shopify/vendors/${encodeURIComponent(vendorName)}/products?status=${status}`
      );

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      console.log('✅ Vendor ürünleri getirildi:', data);
      return data;

    } catch (error) {
      console.error('❌ Vendor ürünleri getirme hatası:', error);
      throw error;
    }
  }

  // Vendor istatistiklerini getir
  async getVendorStats(vendorName) {
    try {
      console.log('📊 Vendor istatistikleri getiriliyor:', vendorName);
      const response = await fetch(
        `https://medi-panel.cloud/api/shopify/vendors/${encodeURIComponent(vendorName)}/stats`
      );

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      console.log('✅ Vendor istatistikleri getirildi:', data);
      return data;

    } catch (error) {
      console.error('❌ Vendor istatistikleri getirme hatası:', error);
      throw error;
    }
  }



  // 🎯 GEÇİCİ FİYAT DEĞİŞİKLİĞİ - CLASS İÇİNE EKLE
  async applyTemporaryPriceChange(vendorName, percentage, changeType, productIds = null) {
    try {
      console.log('🎯 Geçici fiyat değişikliği:', { vendorName, percentage, changeType, productIds });

      const url = `https://medi-panel.cloud/api/shopify/price-management/vendors/${encodeURIComponent(vendorName)}/apply-temporary-change?percentage=${percentage}&changeType=${changeType}`;

      console.log('🔍 API URL:', url);

      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: productIds ? JSON.stringify(productIds) : '[]'
      });

      console.log('📡 Response status:', response.status);

      if (!response.ok) {
        const errorText = await response.text();
        console.error('❌ HTTP Hatası:', errorText);
        throw new Error(`HTTP ${response.status}: ${errorText}`);
      }

      const data = await response.json();
      console.log('✅ Başarılı response:', data);
      return { success: true, message: 'Geçici fiyat değişikliği başarıyla uygulandı' };

    } catch (error) {
      console.error('❌ Geçici fiyat değişikliği hatası:', error);
      return {
        success: false,
        message: 'İşlem sırasında hata oluştu: ' + error.message
      };
    }
  }

  // 🔄 ORİJİNAL FİYATA DÖN - CLASS İÇİNE EKLE
  async resetToOriginalPrice(vendorName, productIds = null) {
    try {
      console.log('🔄 Orijinal fiyata dönülüyor:', { vendorName, productIds });

      const url = `https://medi-panel.cloud/api/shopify/price-management/vendors/${encodeURIComponent(vendorName)}/reset-to-original`;

      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: productIds ? JSON.stringify(productIds) : '[]'
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      const data = await response.json();
      console.log('✅ Orijinal fiyata dönme sonucu:', data);
      return { success: true, message: 'Ürünler orijinal fiyatlarına başarıyla döndürüldü' };

    } catch (error) {
      console.error('❌ Orijinal fiyata dönme hatası:', error);
      return { success: false, message: 'İşlem sırasında hata oluştu: ' + error.message };
    }
  }

  // 💰 KALICI FİYAT DEĞİŞİKLİĞİ - CLASS İÇİNE EKLE
  async updatePermanentPrice(vendorName, newPrice, productIds = null) {
    try {
      console.log('💰 Kalıcı fiyat güncellemesi:', { vendorName, newPrice, productIds });

      const url = `https://medi-panel.cloud/api/shopify/price-management/vendors/${encodeURIComponent(vendorName)}/update-permanent-price?newPrice=${newPrice}`;

      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: productIds ? JSON.stringify(productIds) : '[]'
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      const data = await response.json();
      console.log('✅ Kalıcı fiyat güncellemesi sonucu:', data);
      return { success: true, message: 'Kalıcı fiyat güncellemesi başarıyla uygulandı' };

    } catch (error) {
      console.error('❌ Kalıcı fiyat güncellemesi hatası:', error);
      return { success: false, message: 'İşlem sırasında hata oluştu: ' + error.message };
    }
  }

  // 🎯 VENDOR BAZLI TOPLU FİYAT GÜNCELLEME - CLASS İÇİNE EKLE
  async updateVendorPrices(vendorName, request) {
    try {
      console.log('🏪 Vendor toplu fiyat güncelleme:', { vendorName, request });

      const response = await fetch(
        `https://medi-panel.cloud/api/shopify/vendors/${encodeURIComponent(vendorName)}/bulk-price-update`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(request)
        }
      );

      if (!response.ok) {
        const errorText = await response.text();
        console.error('❌ HTTP Hatası:', errorText);
        throw new Error(`HTTP ${response.status}: ${errorText}`);
      }

      const data = await response.json();
      console.log('✅ Vendor toplu fiyat güncelleme sonucu:', data);
      return data;

    } catch (error) {
      console.error('❌ Vendor toplu fiyat güncelleme hatası:', error);
      throw error;
    }
  }

  // 🗑️ POLİTİKA KALDIR
  async removePricePolicy(policyId) {
    try {
      console.log('🗑️ Politika kaldırılıyor:', policyId);

      const response = await fetch(
        `https://medi-panel.cloud/api/shopify/price-management/policies/${policyId}`,
        {
          method: 'DELETE'
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      const data = await response.json();
      console.log('✅ Politika kaldırıldı:', data);
      return data;

    } catch (error) {
      console.error('❌ Politika kaldırma hatası:', error);
      return { success: false, message: 'Politika kaldırma hatası: ' + error.message };
    }
  }

  // 📊 SAYFALI POLİTİKA GEÇMİŞİNİ GETİR
  async getPricePoliciesPaginated(vendorName, page = 0, size = 10) {
    try {
      console.log('📊 Sayfalı politika geçmişi getiriliyor:', { vendorName, page, size });

      const response = await fetch(
        `https://medi-panel.cloud/api/shopify/price-management/policies/${encodeURIComponent(vendorName)}/page?page=${page}&size=${size}`
      );

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      const data = await response.json();
      console.log('✅ Sayfalı politika geçmişi:', data.content);
      return data.content; // 🔥 Page'in content kısmını dön

    } catch (error) {
      console.error('❌ Sayfalı politika geçmişi getirme hatası:', error);
      return [];
    }
  }



  ////////

  // 📊 POLİTİKA GEÇMİŞİNİ GETİR
  async getPricePolicies(vendorName) {
    try {
      console.log('📊 Politika geçmişi getiriliyor:', vendorName);

      const response = await fetch(
        `https://medi-panel.cloud/api/shopify/price-management/policies/${encodeURIComponent(vendorName)}`
      );

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      const data = await response.json();
      console.log('✅ Politika geçmişi:', data);
      return data;

    } catch (error) {
      console.error('❌ Politika geçmişi getirme hatası:', error);
      return []; // Hata durumunda boş array dön
    }
  }



  // Vendor ara
  async searchVendors(query) {
    try {
      console.log('🔍 Vendor aranıyor:', query);
      const response = await fetch(
        `https://medi-panel.cloud/api/shopify/vendors/search?query=${encodeURIComponent(query)}`
      );

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      console.log('✅ Vendor arama sonucu:', data);
      return data;

    } catch (error) {
      console.error('❌ Vendor arama hatası:', error);
      throw error;
    }
  }

  // 🎯 COST PRICE GÜNCELLEME METODU EKLEYİN
  async updateVariantCostPrice(variantId, costPrice) {
    try {
      console.log('📊 Variant cost price güncelleniyor:', { variantId, costPrice });
      const response = await fetch(
        `https://medi-panel.cloud/api/shopify/products/variants/${variantId}/cost-price?costPrice=${encodeURIComponent(costPrice)}`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          }
        }
      );
      console.log('📊 Cost price response status:', response.status);

      if (!response.ok) {
        const errorText = await response.text();
        console.error('❌ Cost price HTTP hatası:', errorText);
        throw new Error(`HTTP ${response.status}: ${errorText}`);
      }

      const data = await response.json();
      console.log('✅ Cost price güncelleme sonucu:', data);
      return data;

    } catch (error) {
      console.error('❌ Cost price güncelleme hatası:', error);
      throw error;
    }
  }

  /////////////////////////////////////////////////////////////////

  // 🔥 YENİ: Aktif ürün sayısını getir
  async getShopifyActiveProductCount() {
    try {
      console.log('🟢 Shopify aktif ürün sayısı alınıyor...');

      const token = localStorage.getItem('token');

      const response = await fetch(`${API_BASE_URL}/analytics/shopify-active-count`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      console.log('📡 Active products response status:', response.status);

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      console.log('✅ Shopify aktif ürün sayısı alındı:', data);
      return data;

    } catch (error) {
      console.error('❌ Shopify aktif ürün sayısı alma hatası:', error);
      throw error;
    }
  }

  // 🔥 YENİ: Draft ürün sayısını getir
  async getShopifyDraftProductCount() {
    try {
      console.log('📝 Shopify draft ürün sayısı alınıyor...');

      const token = localStorage.getItem('token');

      const response = await fetch(`${API_BASE_URL}/analytics/shopify-draft-count`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      console.log('📡 Draft products response status:', response.status);

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      console.log('✅ Shopify draft ürün sayısı alındı:', data);
      return data;

    } catch (error) {
      console.error('❌ Shopify draft ürün sayısı alma hatası:', error);
      throw error;
    }
  }

  // 🔥 YENİ: Tüm Shopify istatistiklerini tek seferde getir
  async getShopifyProductStats() {
    try {
      console.log('📊 Shopify ürün istatistikleri alınıyor...');

      const token = localStorage.getItem('token');

      const response = await fetch(`${API_BASE_URL}/analytics/shopify-stats`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      console.log('📡 Shopify stats response status:', response.status);

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      console.log('✅ Shopify ürün istatistikleri alındı:', data);
      return data;

    } catch (error) {
      console.error('❌ Shopify ürün istatistikleri alma hatası:', error);
      throw error;
    }
  }

  ///////////////////////////////////////////////////////////////////


  // shopifyService.js dosyasına bu metodları EKLEYİN:

  // 📤 EXPORT METODU
  async exportPrices(vendor) {
    try {
      console.log(`📤 Export başlatılıyor: ${vendor}`);

      // DOĞRU TOKEN ALMA
      const token = getToken();
      console.log('🔐 Token bilgisi:');
      console.log('   sessionStorage token:', sessionStorage.getItem('token') ? 'VAR' : 'YOK');
      console.log('   localStorage token:', localStorage.getItem('token') ? 'VAR' : 'YOK');
      console.log('   Kullanılan token:', token ? `${token.substring(0, 30)}...` : 'YOK');

      if (!token) {
        throw new Error('Token bulunamadı. Lütfen login olun.');
      }

      const url = `https://medi-panel.cloud/api/admin/pricing/export/${encodeURIComponent(vendor)}`;
      console.log('🔗 URL:', url);

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
      });

      console.log('📡 Response:', response.status, response.statusText);

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Export failed: ${response.status} - ${errorText}`);
      }

      const blob = await response.blob();
      console.log(`✅ Export başarılı! ${blob.size} bytes`);

      return blob;

    } catch (error) {
      console.error('❌ Export hatası:', error);
      throw error;
    }
  }

  // İMPORT METODUNU DA GÜNCELLEYELİM
  async importPrices(vendor, file) {
    try {
      console.log(`📥 Import başlatılıyor: ${vendor}, file: ${file.name}`);

      const token = localStorage.getItem('token');
      if (!token) {
        throw new Error('Token bulunamadı');
      }

      const formData = new FormData();
      formData.append('file', file);

      // DOĞRU ENDPOINT: /api/admin/pricing/import/{vendor}
      const url = `https://medi-panel.cloud/api/admin/pricing/import/${encodeURIComponent(vendor)}`;
      console.log('🔗 Import URL:', url);

      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`
          // Content-Type'ı fetch otomatik ayarlar (multipart/form-data)
        },
        body: formData
      });

      console.log('📡 Import response:', response.status, response.statusText);

      if (!response.ok) {
        const errorText = await response.text();
        console.error('❌ Import error:', errorText);
        throw new Error(`Import failed: HTTP ${response.status}`);
      }

      const data = await response.json();
      console.log('✅ Import başarılı:', data);

      return {
        success: true,
        message: `Import başarılı! ${data.updated || 0} ürün güncellendi`,
        data: data
      };

    } catch (error) {
      console.error('❌ Import hatası:', error);
      throw error;
    }
  }


  //////////////////////////////////////////////////////////////////////


  // 🎯 VENDOR BAZLI TOPLU FİYAT GÜNCELLEME 
  async updateVendorPrices(vendorName, request) {
    try {
      console.log('🏪 Vendor toplu fiyat güncelleme:', { vendorName, request });

      const response = await fetch(
        `https://medi-panel.cloud/api/shopify/vendors/${encodeURIComponent(vendorName)}/bulk-price-update`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(request)
        }
      );

      if (!response.ok) {
        const errorText = await response.text();
        console.error('❌ HTTP Hatası:', errorText);
        throw new Error(`HTTP ${response.status}: ${errorText}`);
      }

      const data = await response.json();
      console.log('✅ Vendor toplu fiyat güncelleme sonucu:', data);
      return data;

    } catch (error) {
      console.error('❌ Vendor toplu fiyat güncelleme hatası:', error);
      throw error;
    }
  }


  // ⭐ ESKİ METODLARI DA KORU (Mevcut kodunuzla uyumluluk için)
  async getTotalProducts() {
    return this.getShopifyProductCount();
  }

  async getProductCount() {
    return this.getDatabaseProductCount();
  }

  async syncComplete() {
    return this.triggerFullSync();
  }

  async dailySync() {
    return this.triggerIncrementalSync();
  }

  async testSync() {
    return this.triggerTestSync();
  }
}

// ✅ DOĞRU EXPORT - Default export kullan
export default new ShopifyService();